import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { ErrorBoundary } from './components/system/ErrorBoundary';
import { initObservability } from './lib/observability';
import './styles/index.css';

initObservability();

const root = document.getElementById('root');
if (!root) throw new Error('HOTTR. root element missing');

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>,
);
